module.exports = __webpack_public_path__ + "img/4.1176b8a.jpg";